import React from 'react';

const IndicatorIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <rect x="8.5" y="9" width="5" height="5" rx="1" strokeWidth="1.5" />
  </svg>
);

export default IndicatorIcon;
